import { deserializeScoringMatch, matchToLiveView, serializeScoringMatch } from "../../../matchScoringBridge";

/**
 * Map persisted activity document to the live-match shape expected by court hydration.
 * @param {Record<string, unknown> | null} activityDoc
 */
export function activityDocumentToLivePayload(activityDoc) {
  if (!activityDoc) return null;

  const payload = activityDoc.payload && typeof activityDoc.payload === "object" ? activityDoc.payload : {};
  const scoringMatch = deserializeScoringMatch(payload.scoringMatch);
  const view = matchToLiveView(scoringMatch);

  const orchestrationPaused = Boolean(payload.orchestrationPaused);
  let status = typeof payload.status === "string" ? payload.status : null;
  if (!status) {
    if (scoringMatch?.matchWinner) status = "finished";
    else if (orchestrationPaused) status = "paused";
    else if (scoringMatch) status = "live";
    else status = "idle";
  }

  const out = {
    status,
    scoreA: payload.scoreA != null ? payload.scoreA : view.scoreA,
    scoreB: payload.scoreB != null ? payload.scoreB : view.scoreB,
    serving: payload.serving || view.serving,
    sets: Array.isArray(payload.sets) ? payload.sets : view.sets,
    endsSwapped: payload.endsSwapped != null ? Boolean(payload.endsSwapped) : view.endsSwapped,
    winner: payload.winner != null ? payload.winner : view.winner,
    setsToWin: payload.setsToWin,
    pointsToWin: payload.pointsToWin,
    teamA: payload.teamA,
    teamB: payload.teamB,
    matchTimerBaseMs: payload.matchTimerBaseMs,
    matchTimerRunSince: payload.matchTimerRunSince ?? null,
    orchestrationPaused,
  };

  if (scoringMatch) {
    out.scoringMatch = serializeScoringMatch(scoringMatch);
  } else if (payload.scoringMatch != null) {
    out.scoringMatch = payload.scoringMatch;
  }

  Object.keys(out).forEach((k) => {
    if (out[k] === undefined) delete out[k];
  });
  return out;
}

/**
 * @param {Record<string, unknown>} livePayload
 */
export function livePayloadToActivityPayloadFields(livePayload) {
  if (!livePayload) return {};
  const scoringMatch = livePayload.scoringMatch;
  return {
    status: livePayload.status,
    scoreA: livePayload.scoreA,
    scoreB: livePayload.scoreB,
    serving: livePayload.serving,
    sets: livePayload.sets,
    endsSwapped: livePayload.endsSwapped,
    winner: livePayload.winner,
    setsToWin: livePayload.setsToWin,
    pointsToWin: livePayload.pointsToWin,
    teamA: livePayload.teamA,
    teamB: livePayload.teamB,
    matchTimerBaseMs: livePayload.matchTimerBaseMs,
    matchTimerRunSince: livePayload.matchTimerRunSince,
    scoringMatch:
      scoringMatch && typeof scoringMatch === "object"
        ? scoringMatch
        : deserializeScoringMatch(scoringMatch) || scoringMatch,
  };
}
